import categoryService from '../../services/category';

const types = {
  GET_ALL_CATEGORIES: 'categoryService/getAllCategories',    
  GET_CATEGORY_NAME: 'categoryService/getAllCategoryName',    
  GET_CATEGORY_VIDEO_TOTAL: 'categoryService/getAllCategoryTotal',    
  GET_CATEGORY_VIDEO_LIST: 'categoryService/getCategoryVideoList',
};

const state = {
  allCategories: [],
  currentCategoryName: '',
  categoryVideoTotal: 0,
  categoryVideoList: [],
};

const getters = {
  getAllCategories: s => s.allCategories,
  getCategoryVideoTotal: s => s.categoryVideoTotal,
  getCurrentCategoryName: s => s.currentCategoryName,

  getCategoryVideoList: s => s.categoryVideoList,
};


const actions = {
  actionGetAllCategories({ commit }, id) {

    categoryService
    .getAllCategories()
    .then((res) => { 

      const {
        _data,
      } = res;

      switch (id) {
        case 'all':
          commit(types.GET_ALL_CATEGORIES, _data);  
          break;
      
        default: {
          const d = _data.filter(c => (c.id === id));
          
          const {
            name,
          } = d[0];

          commit(types.GET_CATEGORY_NAME, name);
          commit(types.GET_ALL_CATEGORIES, _data);
        }
      }      
    })
    .catch(() => {
      // commit(rootypes.isShowRootLoading);
    });
    
  },
  actionGetCategoryVideoList({ commit }, pageData) {

    categoryService
    .getCategoryVideoList(pageData)
    .then((res) => { 

      const {
        data,
        total_pages,
      } = res;

      commit(types.GET_CATEGORY_VIDEO_TOTAL, total_pages);
      commit(types.GET_CATEGORY_VIDEO_LIST, data);
    })
    .catch(() => {
      // commit(rootypes.isShowRootLoading);
    });
    
  },
  
};

// mutations
const mutations = {
  [types.GET_CATEGORY_NAME](s, name) {
    s.currentCategoryName = name;
  },
  [types.GET_ALL_CATEGORIES](s, data) {
    s.allCategories = data;
  },
  [types.GET_CATEGORY_VIDEO_TOTAL](s, d) {
    s.categoryVideoTotal = d;
  },
  [types.GET_CATEGORY_VIDEO_LIST](s, d) {
    s.categoryVideoList = d;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/category.js